











































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import { Results } from "@/types/NewResults";
import { Action } from "vuex-class";
import { getSession, getSharedSession } from "@/library/api";
import { AxiosResponse, AxiosError } from "axios";
import LearnerResults from "./learnerresults.vue";

@Component({
  components: { LearnerResults }
})
export default class LearnerResultsWrapper extends Vue {
  @Prop() private title!: string;
  @Prop() private propResults!: string;
  @Action private setDisplayError: any;
  
  private sid!: string;
  private results: Results | null = null;
  private isSharedRoute: boolean = false;
  private error: boolean = false; // API error
  private errorMsg: string = "Something went wrong.";
  
  private created() {
    this.sid = this.$route.params.sid;
    this.isSharedRoute = this.$route.name === "shareSession";
    if(this.isSharedRoute) {
      this.fetchSharedSession();
    } else if(!this.propResults) {
      this.fetchSession();
    } else {
      this.results = JSON.parse(this.propResults);
    }
  }

  private fetchSession() {
    getSession(this.sid).then(
      (response: AxiosResponse) => {
        this.results = response && response.data;
        console.log(response.data);
      },
      (error: AxiosError) => {
        console.error(error);
        this.onApiError(error);
      }
    );
  }

  private fetchSharedSession() {
    getSharedSession(this.sid).then(
      (response: AxiosResponse) => {
        this.results = response && response.data;
        console.log(response.data);
      },
      (error: AxiosError) => {
        console.error(error);
        this.onApiError(error);
      }
    );
  }

  private onApiError(error:AxiosError) {
    if(error && error.response) {
      this.error = true;
      const errorMsg = error.response.data.Error;
      if(errorMsg && errorMsg.length>0) {
        this.errorMsg = errorMsg;
      }
    }
  }
}
